import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLanguage$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLanguage extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '302962da92349d8e750aa7e79cc58bd61a7a3fd5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7bdd0d778aaf8c8e046c9cba7eca493dda53fea0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd785172c5b9287edaeac1739f107a81224e89bee', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2.5a8.5 8.5 0 1 0 8.5 8.5A8.51 8.51 0 0 0 11 2.5M17.31 8H14.4a13.1 13.1 0 0 0-1.51-3.73A7 7 0 0 1 17.31 8m-4.06 3a12 12 0 0 1-.1 1.5h-4.3a10.3 10.3 0 0 1 0-3h4.29q.108.746.11 1.5m-4.11 3h3.71A11.6 11.6 0 0 1 11 17.91 11.7 11.7 0 0 1 9.14 14m0-6A11.8 11.8 0 0 1 11 4.09 11.9 11.9 0 0 1 12.85 8zm0-3.73A13.4 13.4 0 0 0 7.59 8H4.68A7 7 0 0 1 9.1 4.27zM4 11a6.7 6.7 0 0 1 .17-1.5h3.17a12 12 0 0 0-.1 1.5q.004.753.1 1.5H4.17A6.7 6.7 0 0 1 4 11m.68 3h2.91c.31 1.313.82 2.57 1.51 3.73A7 7 0 0 1 4.68 14m8.22 3.73A13.2 13.2 0 0 0 14.4 14h2.91a7 7 0 0 1-4.41 3.73m1.76-5.23q.083-.748.09-1.5a12 12 0 0 0-.1-1.5h3.18a6.7 6.7 0 0 1 0 3z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-language", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-language"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-language":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLanguage$1);
            }
            break;
    } });
}

const CosmosIconLanguage = CosmosIconLanguage$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLanguage, defineCustomElement };
